module.exports = __webpack_public_path__ + "static/media/hk.9502d716.svg";